<template>
  <div class="contact-us-page">
    <div class="bgImg">
      <img src="@assets/images/ctus_bg.png" alt="" />
    </div>
    <div class="main">
      <div class="ctus_main">
        <span class="gray">公司&nbsp;&nbsp;|&nbsp;&nbsp;Company</span>
        <div class="black">
          上海步频电子科技有限公司
          <div class="ctus_icon">
            <img
              style="width:28px;height:28px;"
              src="@assets/images/gongsi@2x.png"
              alt=""
            />
          </div>
        </div>
      </div>
      <div class="ctus_main" style="padding-bottom:30px">
        <span class="gray">地址&nbsp;&nbsp;|&nbsp;&nbsp;Address</span>
        <div class="black">
          <a href="https://uri.amap.com/marker?position=121.312827,31.200953"
            >上海市闵行区泰虹路万科时一区 168弄1号楼202室</a
          >
          <div class="ctus_icon">
            <img
              style="width:28px;height:28px;"
              src="@assets/images/dizhi@2x.png"
              alt=""
            />
          </div>
        </div>
      </div>
      <div class="ctus_main">
        <a href="http://www.shbupin.com">
          <span class="gray">网址&nbsp;&nbsp;|&nbsp;&nbsp;Website</span>
          <div class="black">
            <span class="gs3w blue">www.shbupin.com</span>
            <div class="ctus_icon">
              <img
                style="width:28px;height:28px;"
                src="@assets/images/wangzhi_2@2x.png"
                alt=""
              />
            </div>
          </div>
        </a>
      </div>
      <div class="ctus_main">
        <span class="gray">电话&nbsp;&nbsp;|&nbsp;&nbsp;Telephone</span>
        <div class="black">
          <a href="tel:54395802" class="gs3w">54395802</a>
          <div class="ctus_icon">
            <img
              style="width:28px;height:28px;"
              src="@assets/images/dianhua@2x.png"
              alt=""
            />
          </div>
        </div>
      </div>
      <div class="ctus_main">
        <span class="gray">传真&nbsp;&nbsp;|&nbsp;&nbsp;fax</span>
        <div class="black">
          021—54306607
          <div class="ctus_icon">
            <img
              style="width:28px;height:28px;"
              src="@assets/images/chuanzhen@2x.png"
              alt=""
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import { getConcatUsData } from "@api/common";

export default {
  data() {
    return {
      info: {
        companyName: "",
        image: "",
        logoImage: "",
        address: "",
        website: "",
        tel: "",
        fax: ""
      }
    };
  }
};
</script>

<style scoped lang="scss">
.contact-us-page {
  // position: relative;
  .bgImg {
    width: 100%;
    img {
      width: 100%;
    }
  }
  .main {
    position: relative;
    top: -75px;
    left: 0;
    background-color: #fff;
    width: 90%;
    height: 100%;
    margin: 0 auto;
    box-shadow: 0 0 11px 0 rgba(0, 0, 0, 0.2);
    border-radius: 9px;
    padding: 15px 0 40px 0;
  }
  .ctus_main {
    padding: 15px 0 10px 5px;
    margin: 0 auto;
    width: 90%;
    border-bottom: 1px solid #ccc;
  }
  .ctus_icon {
    // border-left: 1px solid #D8D8D8;
    // padding: 5px;
    float: right;
    position: relative;
    top: 0;
    right: 0;
  }
}

.gray {
  color: #999999;
  font-family: SourceHanSansCN-Regular;
  font-size: 0.3rem;
}
.black {
  color: #202020;
  font-size: 0.25rem;
  font-weight: 700;
  margin-top: 15px;
  height: 0.6rem;
  a {
    display: block;
    width: 70%;
    float: left;
    height: 30px;
    line-height: 30px;
    color: #345cfe;
  }
  .blue {
    color: #345cfe;
  }
}
</style>
